import { ITC, ERRORLIST } from "../../util/eventTypes"
import BaseEvent from "../../util/baseEvent"
export default class WsStaticConnect extends BaseEvent {
  constructor(options) {
    super()
    this.options = options
    this.$logger.setPrefix("ws-static")
  }
  connect() {
    const list = this.options.wsStaticList
    if (!list || list.length === 0) {
      this.warn("static EP list is empty!")
      this.broadcast(ITC.ERROR, ERRORLIST.WS_STATIC_FAIL, {
        errorcode: "EMPTY_WS_STATIC_LIST",
        event_steps: "ws_static"
      })
      return
    }
    const wsStatic = list.shift()
    this.rlog("start_ws_static", {
      host: wsStatic,
      event_steps: "ws_static"
    })
    this.broadcast(ITC.FETCH_WS_SERVICE_SUCCESS, wsStatic, "")
  }
}
